import { render, staticRenderFns } from "./CardEnvironmentalRestrictionsChart.vue?vue&type=template&id=0cb6ab7c"
import script from "./CardEnvironmentalRestrictionsChart.vue?vue&type=script&lang=js"
export * from "./CardEnvironmentalRestrictionsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports